import { OrderHistoryData, OrderHistoryStatus } from "../modules/user/stock-order-history/types";

const consist = (a: any, b: any) => {
    return a.toLowerCase().indexOf(b.toLowerCase()) !== -1;
};

export const handleFilter = (item: any, term: any) => {
    return consist(item.currency, term);
};

export const filterOrderHistoryByStatus = (orderHistory: OrderHistoryData[], statuses: OrderHistoryStatus[]) => {
    return orderHistory.filter(item => statuses.includes(item.status));
}